export enum ClientRequestStepNames {
    FORM_UPLOAD = "Form Upload",
    AUTH = "Authentication",
}
